import procedimento from './procedimento'
import exportacao from './exportacao'

export default [
    {
        path: 'apac',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...procedimento,
            ...exportacao
        ]
    }
]